export default 'composer require firebase/php-jwt';
